import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

interface IGetAllMenuListRequest {
  status?: string;
}

type IGetAllMenuListResponse = BaseResponse<any>;

async function getAllMenuList(status?: string): Promise<IGetAllMenuListResponse> {
  try {
    return (await axiosInstance.get("/Menu/All", { params: { status } })).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}
export function useGetAllMenuList(status?: string) {
  return useQuery<any | undefined, Error>(
    [QueryKeys.GetAllMenuList, status],
    () => getAllMenuList(status)
  );
}

